import { styled } from '@mui/system';
import { FormContainer } from '../../../components/Form/FormComponents';

export const CustomFieldsFormContainer = styled(FormContainer)`
  align-content: start;
  align-items: start;
`;
